module.exports = __webpack_public_path__ + "static/media/hualian_pic3.e761e7ef.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/hualian_pic3.jpg
 ** module id = 446
 ** module chunks = 0
 **/